import React from "react";
import "./selectedDevice.css"
import {f_101_formatDateExactly} from "../DevServices/service_functions"

const StateList = (props) => {
  const {rx_state_list} = props
  //console.log(rx_state_list)
  //if (rx_state_list.length === 0) return <></>
  if (!rx_state_list || rx_state_list.length === 0) return null;
  //RRR create cervice delete State_id
  //console.log(rx_state_list)
  return (
    <>
    {/* <p>Hello from StatusList</p> */}
    <DataTable data = {rx_state_list} />
    </>
  )
}

export default StateList;

const DataTable = ({ data }) => {
  if (!data || data.length === 0) {
      return <p>No data available</p>;
  }
  console.log()
  return (
    <div className="container mt-5">
    <h2>State status</h2>
    <table className="table table-striped">
        <thead>
            <tr>
                <th>ID</th>
                {/* <th>Dev ID</th> */}
                <th>Code</th>
                <th>Value</th>
                <th>Description</th>
                <th>Data Created</th>
                <th>Data Updated</th>
            </tr>
        </thead>
        <tbody>
            {data.map((item) => (
                <tr key={item.id}>
                    <td>{item.id}</td>
                    {/* <td>{item.dev_id}</td> */}
                    <td>{item.code}</td>
                    <td className="text-left">
                    <div className={`${item?.color_code && 'SD__circle SD__circle--color-' + item.color_code}`}>
                    {item.value !== null ? item.value : '-'}
                    </div>
                      
                      </td>
                    <td>{item.description !== null ? item.description : '-'}</td>
                    <td>{f_101_formatDateExactly(item.date_created)}</td>
                    <td>{f_101_formatDateExactly(item.date_updated)}</td>
{/*                     <td>{new Date(item.date_created).toLocaleString()}</td>
                    <td>{new Date(item.date_updated).toLocaleString()}</td> */}
                    
                </tr>
            ))}
        </tbody>
    </table>
</div>
  );
};


const TableColorCircle = ({ number, variant }) => (
  <div className={`td-color-circle td-color-circle--${variant}`}>
    {number}
  </div>
);